import React, { useEffect } from 'react';

const StyledCalendarEvent = ({event, backgroundColor}) => {
  useEffect(() => {
      const currentNode = document.querySelector(`[data-event-id="${event.id}"]`);
      if (currentNode) {
          let ancestor = currentNode.closest('a'); // This finds the nearest anchor tag which is usually the event wrapper
          if (ancestor) {
              ancestor.style.backgroundColor = backgroundColor; // Change to desired background color
              ancestor.style.borderColor = backgroundColor; // Change to desired border color
          }
      }
  }, [event, backgroundColor]);

  return (
    <div className='fc-event-main' data-event-id={event.id} style={{ backgroundColor, padding: '5px', borderRadius: '5px', color: 'white' }}>
        <b>{event.title}</b>
        {event.status === 'pending' && (
            <i style={{ marginLeft: '5px' }}>Pending</i>
        )}
        {event.status === 'confirmed' && (
            <i style={{ marginLeft: '5px' }}>Confirmed</i>
        )}
        {event.status === 'dropped-off' && (
            <i style={{ marginLeft: '5px' }}>Dropped Off</i>
        )}
        {event.status === 'picked-up' && (
            <i style={{ marginLeft: '5px' }}>Picked Up</i>
        )}
        {event.status === 'paid' && (
            <i style={{ marginLeft: '5px' }}>Paid</i>
        )}
    </div>
  )
};

export default StyledCalendarEvent;